import Vue from 'vue';
import Vuex from 'vuex';
import videosModule from './modules/videos';
import themesModule from './modules/themes';
import liveModule from './modules/lives';
import layoutModule from './modules/layouts';
import podcast from './modules/podcast';
import common from './modules/common';
import custom from './modules/custom'

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    videos: videosModule,
    themes: themesModule,
    live: liveModule,
    layout: layoutModule,
    podcast: podcast,
    common,
    custom,
  },
  strict: debug,
});



// WEBPACK FOOTER //
// ./src/store/index.js